import { Alert, Snackbar } from "@mui/material";
import React from "react";

interface SuccessAlertProps {
  show: boolean;
  message: string;
  onDismiss: any;
}

const SuccessAlert: React.FC<SuccessAlertProps> = ({ show, message, onDismiss }) => {
  return (
    <Snackbar 
      open={show} 
      anchorOrigin={{ vertical: "top", horizontal: "center" }} 
      onClose={onDismiss} 
      autoHideDuration={3000}
      sx={{
        mt: 8,
      }}>
      <Alert onClose={onDismiss} severity="success" variant="filled" sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SuccessAlert;
